import React from "react";
import toast from "react-hot-toast";
import moment from "moment";
import "./TicketView.css";
import DefaultAirlineImage from "../../../Assets/Images/default-airline.png";
import images from "../../../Utils/importImages";

const TicketFormat = React.forwardRef(({ Data, nav }, ref) => {
  return (
    <div ref={ref} className="air-ticket-view proxima_regular">
      {nav}
      <div className="confirmed--booking--info">
        <div className="confirmed--msg proxima_semibold">
          <div className="left--confirmed--msg">Your Confirmed Booking</div>
          <div className="right--confirmed--msg">
            <div className="booking--date--ticket proxima_regular">
              <span className="proxima_light">Booking Date:</span>{" "}
              {moment(Data.BookingDate).format("DD MMM, YYYY")}
            </div>
            <div className="booking--date--ticket proxima_regular">
              <span className="proxima_light">Booking ID:</span>{" "}
              {Data.Booking_id}
            </div>
          </div>
        </div>
      </div>

      <div className="ticket-view-wrapper">
        {Data?.Data?.map((itemm, id) => {
          return (
            <div className="ticket--data--internal" key={id}>
              <div className="ticket--head--userdb">
                <div className="ticket--head--data--left">
                  <div className="ticket--onward-return--timings">
                    <div className="ticket--onward--return proxima_regular">
                      {itemm.mainHeading.heading}
                    </div>
                    <div className="ticket--timings">
                      <img src={images["ticket-timing-ico.svg"]} alt="" />
                      {itemm.mainHeading.time}
                    </div>
                  </div>
                  <div className="ticket--subflight--details">
                    {itemm.mainHeading.Data.map((item) => (
                      <div className="route--row" style={{ paddingTop: "5px" }}>
                        <div className="left--route--row">
                          <div className="route--row--source">{item.From}</div>
                          <div className="route--row--stops proxima_regular">
                            {item?.Stops ||
                              `${
                                itemm.WrappedData.length - 1 == 0
                                  ? "Non"
                                  : itemm.WrappedData.length - 1
                              } Stop${
                                itemm.WrappedData.length - 1 > 1 ? "s" : ""
                              }`}
                          </div>
                          <div className="route--row--source">{item.To}</div>
                        </div>
                          {/* <div className="route--row--non-refundable">
                            <span
                              className={
                                item.FareType.color == "non-refundable"
                                  ? "non-refundable--ticket"
                                  : "refundable--ticket"
                              }
                            >
                              {item.FareType.status}
                            </span>
                          </div> */}
                          
                        <div className="right--route--row">
                          <div className="route--row--bookingclass">
                            {item.FareName}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="ticketContent--userdb">
                {itemm.WrappedData.map((item, id) => {
                  return (
                    <>
                      <div className="ticketContent--segment">
                        <div className="flight--info--route">
                          <div className="ticket--segment--data">
                            <div className="ticket--segment-airline">
                              <div className="segment--airline-logo">
                                <img
                                  src={
                                    item.AirlineLogo == "UnKnown"
                                      ? DefaultAirlineImage
                                      : item.AirlineLogo
                                  }
                                  alt=""
                                />
                              </div>
                              <div className="segment--airline-info">
                                <div className="segment--airline-name">
                                  {item.AirlineName}
                                </div>
                                <div className="segment--airline-number">
                                  <ul className="segment--airline-number-list">
                                    <li className="proxima_regular">
                                      {item.AirlineCodeName}
                                    </li>
                                    <li>{item.Carrier}</li>
                                  </ul>
                                </div>
                                <div className="segment--airline-operatedby">
                                  {item.OperatedBy}
                                </div>
                              </div>
                            </div>
                            <div className="segment--airline-route">
                              <div className="segment--route-from">
                                <div className="segment--route-datetime">
                                  <span className="segment--route-timebold proxima_semibold">
                                    {item.FromData.Time}{" "}
                                  </span>
                                  <span className="segment--route-date">
                                    {item.FromData.Date}
                                  </span>
                                </div>
                                <div className="segment--route-name">
                                  {item.FromData.Text1}
                                </div>
                                <div className="segment--route-terminal">
                                  {item.FromData.Text2}
                                </div>
                              </div>

                              <div className="segment--segment-timing">
                                <img src={images["timings-ico.svg"]} alt="" />{" "}
                                {item.Duration}
                              </div>

                              <div className="segment--route-from">
                                <div className="segment--route-datetime">
                                  <span className="segment--route-timebold proxima_semibold">
                                    {item.ToData.Time}{" "}
                                  </span>
                                  <span className="segment--route-date">
                                    {item.ToData.Date}
                                  </span>
                                </div>
                                <div className="segment--route-name">
                                  {item.ToData.Text1}
                                </div>
                                <div className="segment--route-terminal">
                                  {item.ToData.Text2}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="segment--traveller-table">
                          <table
                            className="traveller--segment-table"
                            cellpadding="0"
                            cellspacing="5"
                          >
                            <tr>
                              <th>Traveller (s)</th>
                              <th>Check-In</th>
                              <th width="70">Cabin</th>
                              <th width="70">Seat</th>
                              <th>Meal</th>
                              <th>Wheelchair</th>
                              <th>Class</th>
                              <th>Status</th>
                            </tr>
                            {item.Travellers.map((traveller, id) => {
                              return (
                                <tr>
                                  <td>
                                    <span className="segment--traveller--name proxima_semibold">
                                      {traveller.name} ({traveller.type})
                                    </span>
                                    <ul className="segment--traveller--ticketpnr">
                                      <li>
                                        Ticket No.: {traveller.ticket_number}
                                      </li>
                                      <li>PNR: {traveller.pnr}</li>
                                      <li>
                                        {traveller.refundable
                                          ? "Refundable"
                                          : "Non-Refundable"}
                                      </li>
                                    </ul>
                                  </td>
                                  <td>{traveller["checkin-bag"]}</td>
                                  <td>{traveller["cabin-bag"]}</td>
                                  <td>{traveller.seat}</td>
                                  <td>{traveller.meal}</td>
                                  <td>{traveller.isWheelChair ? "♿ Yes" : "-"}</td>
                                  <td>{traveller.class}</td>
                                  <td>{traveller.status}</td>
                                </tr>
                              );
                            })}
                          </table>
                        </div>
                      </div>

                      <div className="ticketContent-tagging-wrapper">
                        {Array.isArray(item?.Tags) && item.Tags.length > 0 && (
                          <div className="ticketContent-tagging-wrapper">
                            {item.Tags.map((item, id) => {

                              if (item.mode === 3) {
                                return (
                                  <div
                                    className="ticketContent--tagging"
                                    key={id}
                                  >
                                    <div className="tagging-inter-content">
                                      {item.Heading}
                                    </div>
                                  </div>
                                );
                              } else if (item.mode === 2) {
                                return (
                                  <div
                                    className="ticketContent--tagging"
                                    key={id}
                                  >
                                    <div className="tagging--ico">
                                      <img src={images[item.Icon]} alt="" />
                                    </div>
                                    <div className="tagging--content">
                                      <div className="tagging-timing proxima_semibold">
                                        {item.Message_1}
                                      </div>
                                      <div className="tagging-inter-content">
                                        {item.Message_2}
                                      </div>
                                    </div>
                                  </div>
                                );
                              } else if (item.mode == 1) {
                                return (
                                  <div
                                    className="ticketContent--tagging"
                                    key={id}
                                  >
                                    <div className="tagging--ico">
                                      <img src={images[item.Icon]} alt="" />
                                    </div>
                                    <div className="tagging--content">
                                      <div className="tagging-timing proxima_semibold">
                                        {item.Heading}
                                      </div>
                                      <div className="tagging-description">
                                        {item.Message}
                                      </div>
                                    </div>
                                  </div>
                                );
                              } else {
                                return (
                                  <div
                                    className="ticketContent--tagging"
                                    key={id}
                                  >
                                    <div className="tagging--ico">
                                      <img src={images[item.Icon]} alt="" />
                                    </div>
                                    <div className="tagging--content">
                                      <div className="tagging-timing proxima_semibold">
                                        {item.Message_1}
                                      </div>
                                      <div className="tagging-description">
                                        {item.Message_2}
                                      </div>
                                    </div>
                                  </div>
                                );
                              }
                            })}
                          </div>
                        )}
                      </div>
                    </>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
});

export default TicketFormat;
